import {gql} from "@apollo/client";
import {ApolloClientQuery} from "./_setup";
import { createLogSession } from "../restful/logs/logs";

const GET_USER_FAVOURITE_SYMBOL = gql`
    query getUserFavouriteSymbol($userid: String,$server:String) {
        getUserFavouriteSymbol(userid: $userid,server:$server) {
            ... on UserFavouriteSymbol {
                favouriteSymbol {
                    name
                    symbolId
                    baseSymbolId
                }
                favouriteSymbolMt5 {
                    symbol
                    baseSymbolId
                }
            }
            ... on BaseError {
                errKey
                errMsg
            }
        }
    }
`;

export async function getUserFavouriteSymbol(userid, server) {

    const variables = {
        userid: userid,
        server: server,
        context: {
            headers: {
                authorization: "Bearer " + localStorage.getItem("a_t"),
            },
        },
    };

    const execute = await ApolloClientQuery(GET_USER_FAVOURITE_SYMBOL, variables, false);

    return execute;
}

const UPDATE_USER_FAVOURITE_SYMBOL = gql`
    mutation updateUserFavouriteSymbol($input: UserFavouriteSymbolInput) {
        updateUserFavouriteSymbol(input: $input) {
            ... on UserFavouriteSymbol {
                favouriteSymbol {
                    symbolId
                    name
                }

            }
            ... on BaseError {
                errKey
                errMsg
            }
        }
    }
`;

export async function updateUserFavouriteSymbol(userid, favouriteSymbol, server) {
    const session = createLogSession("User", "FavouriteSymbol", "updateUserFavouriteSymbol");
    session.create({ description: "Updating favourite symbol", logData: { userid, favouriteSymbol, server } });

    const variables = {
        input: {
            user: userid,
            favouriteSymbol: favouriteSymbol,
            server: server
        },
        context: {
            headers: {
                authorization: "Bearer " + localStorage.getItem("a_t"),
            },
        },
    };

    try {
        const execute = await ApolloClientQuery(UPDATE_USER_FAVOURITE_SYMBOL, variables, true);
        const err = execute?.updateUserFavouriteSymbol?.__typename === "BaseError" ? execute?.updateUserFavouriteSymbol : null;
        session.create({ description: err ? "Favourite symbol update failed" : "Favourite symbol updated", status: err ? "error" : "info", logData: err ? { error: err, userid, favouriteSymbol, server } : { userid, favouriteSymbol, server } });
        return execute;
    } catch (e) {
        session.create({ description: "Favourite symbol update failed", status: "error", logData: { userid, favouriteSymbol, server, error: e } });
        throw e;
    }
}